import { render, staticRenderFns } from "./PositionSummaryComponent.vue?vue&type=template&id=48cc46fe&"
import script from "./PositionSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./PositionSummaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports